import { render } from "./ContactIcons.vue?vue&type=template&id=25ace032&scoped=true"
import script from "./ContactIcons.vue?vue&type=script&lang=js"
export * from "./ContactIcons.vue?vue&type=script&lang=js"

import "./ContactIcons.vue?vue&type=style&index=0&id=25ace032&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ace032"]])

export default __exports__